import {FC} from "react";

interface IProps {}

export const TickIcon: FC<IProps> = ({}: IProps) => {
    return (
        <svg
            width="38"
            height="39"
            viewBox="0 0 38 39"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.1106 38.7392C16.4319 38.7392 14.8241 38.0352 13.6724 36.7635L1.16076 22.9333C0.0837923 21.7422 0.17387 19.9026 1.3639 18.8246C2.55585 17.7466 4.39361 17.8367 5.46866 19.0279L17.9803 32.8561C18.0052 32.8829 18.0531 32.929 18.1489 32.9156C18.2486 32.9002 18.2735 32.8408 18.2888 32.8062L31.7567 2.11534C32.4025 0.64409 34.1137 -0.0234444 35.5874 0.621065C37.0572 1.26749 37.726 2.98426 37.0802 4.45551L23.6123 35.1464C22.7902 37.0186 21.0981 38.3325 19.0821 38.6586C18.7583 38.7123 18.4325 38.7392 18.1106 38.7392Z"
                fill="white"
            />
        </svg>
    );
};
